import { useSelector } from 'react-redux'
import { RootState } from 'store'

export type SettingsType =
  | 'SHOW_FLOURS'
  | 'SHOW_WHEAT'
  | 'SHOW_WHEAT_DATA_ANALYSIS'
  | 'SHOW_WHEAT_TARGET_BIN'
  | 'SHOW_BAKER_MODULE'
  | 'SHOW_BAKER_DATA_ANALYSIS'
  | 'SHOW_WHEAT_STORAGE'

export const useSystemSettings = (key?: SettingsType) => {
  const settings = useSelector((state: RootState) => state.user?.settings ?? {})

  const isSettingEnabled = (target: SettingsType) => !!settings[target]
  const isEnabled = isSettingEnabled(key)

  return { isSettingEnabled, isEnabled }
}
